module.exports = __webpack_public_path__ + "media/Vermillion.7e14a2d4.mp3";